// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ClusterSpecInput
 */
export interface ClusterSpecInput {
  /**
   *
   * @type {string}
   * @memberof ClusterSpecInput
   */
  cloudProvider?: string;
  /**
   *
   * @type {object}
   * @memberof ClusterSpecInput
   */
  _configuration?: object;
  /**
   *
   * @type {string}
   * @memberof ClusterSpecInput
   */
  isolationUnitId?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterSpecInput
   */
  partitionId?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterSpecInput
   */
  region?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ClusterSpecInput
   */
  roles?: Array<string>;
}

/**
 * Check if a given object implements the ClusterSpecInput interface.
 */
export function instanceOfClusterSpecInput(
  value: object,
): value is ClusterSpecInput {
  return true;
}

export function ClusterSpecInputFromJSON(json: any): ClusterSpecInput {
  return ClusterSpecInputFromJSONTyped(json, false);
}

export function ClusterSpecInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClusterSpecInput {
  if (json == null) {
    return json;
  }
  return {
    cloudProvider:
      json['cloud_provider'] == null ? undefined : json['cloud_provider'],
    _configuration:
      json['configuration'] == null ? undefined : json['configuration'],
    isolationUnitId:
      json['isolation_unit_id'] == null ? undefined : json['isolation_unit_id'],
    partitionId:
      json['partition_id'] == null ? undefined : json['partition_id'],
    region: json['region'] == null ? undefined : json['region'],
    roles: json['roles'] == null ? undefined : json['roles'],
  };
}

export function ClusterSpecInputToJSON(json: any): ClusterSpecInput {
  return ClusterSpecInputToJSONTyped(json, false);
}

export function ClusterSpecInputToJSONTyped(
  value?: ClusterSpecInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloud_provider: value['cloudProvider'],
    configuration: value['_configuration'],
    isolation_unit_id: value['isolationUnitId'],
    partition_id: value['partitionId'],
    region: value['region'],
    roles: value['roles'],
  };
}
